// T0/T8 — Chargement unifié + validation légère des fichiers JSON data-driven.
//
// IMPORTANT : `require.context` exige un chemin LITTÉRAL au site d'appel (contrainte webpack).
// On ne peut donc pas passer un chemin dynamique. Pattern : la page crée le contexte avec un
// chemin littéral et le passe à `loadFromContext`, qui centralise lecture + validation + logs.
//
//   import { loadFromContext } from '../data/loadData';
//   const ctx = require.context('../data/config', false, /\.json$/);
//   const items = loadFromContext(ctx); // -> [{ filename, data }]

const REQUIRED_META = ['title'];

// Valide le bloc metadata normalisé (cf. T8 / CHANGELOG_SCHEMA.md). Ne jette jamais : renvoie
// la liste des problèmes (vide si OK) pour logguer un avertissement explicite plutôt qu'un crash.
export function validateMetadata(json, filename) {
  const issues = [];
  if (!json || typeof json !== 'object') {
    issues.push('JSON vide ou invalide');
    return issues;
  }
  const meta = json.metadata || {};
  REQUIRED_META.forEach((k) => {
    if (!meta[k]) issues.push(`metadata.${k} manquant`);
  });
  if (!meta.schemaVersion) issues.push('metadata.schemaVersion manquant (recommandé)');
  return issues;
}

// Charge tous les JSON d'un contexte require.context. Renvoie [{ filename, data }].
// Les fichiers illisibles sont ignorés (avec log d'erreur) au lieu de casser toute la page.
export function loadFromContext(context, { validate = true } = {}) {
  return context
    .keys()
    .map((key) => {
      let data;
      try {
        data = context(key);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`[loadData] Échec de chargement ${key}:`, e);
        return null;
      }
      const filename = key.replace(/^\.\//, '');
      if (validate) {
        const issues = validateMetadata(data, filename);
        if (issues.length) {
          // eslint-disable-next-line no-console
          console.warn(`[loadData] ${filename}: ${issues.join(' ; ')}`);
        }
      }
      return { filename, data };
    })
    .filter(Boolean);
}

// Tri pratique par metadata.module puis title (pour un affichage homogène).
export function sortByModuleThenTitle(items) {
  const order = ['ENVIRONMENT', 'CAMPAIGN', 'PERFORMANCE', 'TRANSVERSE'];
  return [...items].sort((a, b) => {
    const ma = order.indexOf(a.data?.metadata?.module);
    const mb = order.indexOf(b.data?.metadata?.module);
    if (ma !== mb) return (ma === -1 ? 99 : ma) - (mb === -1 ? 99 : mb);
    return (a.data?.metadata?.title || '').localeCompare(b.data?.metadata?.title || '');
  });
}
